import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import Icon from '@components/Icon/Icon';

const messages = defineMessages({
  splitGroup: {
    id: 'autoCuration.pdfSplitEditor.splitGroup',
    defaultMessage: 'Split Group',
  },
  deletePages: {
    id: 'autoCuration.pdfSplitEditor.deletePages',
    defaultMessage: 'Delete {count} {count, plural, one {Page} other {Pages}}',
  },
  groupPages: {
    id: 'autoCuration.pdfSplitEditor.groupPages',
    defaultMessage: 'Group {count} {count, plural, one {Page} other {Pages}}',
  },
});

interface GridViewControlsProps {
  selectedPages: number[];
  pageGroups: number[][];
  onGroupSelectedPages: () => void;
  onSplitSelectedGroups: () => void;
  onDeleteSelectedPages: () => void;
  onClearSelection: () => void;
}
export const GridViewControls = ({
  pageGroups,
  selectedPages,
  onGroupSelectedPages,
  onSplitSelectedGroups,
  onDeleteSelectedPages,
  onClearSelection,
}: GridViewControlsProps) => {
  const { formatMessage } = useIntl();
  const deletablePageCount = React.useMemo(() => {
    return selectedPages.filter((page) => {
      const group = pageGroups.find((g) => g.includes(page));
      return !group || group.length === 1;
    }).length;
  }, [pageGroups, selectedPages]);

  const hasSelectedPagesInGroup = () => {
    if (selectedPages.length === 0 || pageGroups.length === 0) return false;

    return selectedPages.some((page) => {
      const group = pageGroups.find((g) => g.includes(page));
      return group && group.length > 1;
    });
  };

  if (selectedPages.length === 0) {
    return null;
  }

  return (
    <>
      <Button
        variant="contained"
        startIcon={<Icon name="merge" type="fas" rotation={90} />}
        onClick={onGroupSelectedPages}
        disabled={selectedPages.length < 2}
        color="success"
      >
        {formatMessage(messages.groupPages, {
          count: selectedPages.length,
        })}
      </Button>
      {hasSelectedPagesInGroup() && (
        <Button
          variant="contained"
          startIcon={<Icon name="split" type="fas" rotation={-90} />}
          onClick={onSplitSelectedGroups}
          color="error"
        >
          {formatMessage(messages.splitGroup)}
        </Button>
      )}
      <Button
        variant="contained"
        startIcon={<Icon name="trash" type="fas" />}
        onClick={onDeleteSelectedPages}
        disabled={deletablePageCount === 0}
        color="error"
      >
        {formatMessage(messages.deletePages, {
          count: selectedPages.length,
        })}
      </Button>
      <IconButton onClick={onClearSelection} color="error">
        <Icon name="xmark" type="fas" />
      </IconButton>
    </>
  );
};
